import React from 'react';

import Menu, { MenuProps } from '@mui/material/Menu';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import classNames from 'classnames';

export type MenuWindowProps = MenuProps;

const useStyles = createUseStyles((theme: Theme) => ({
  menu: {
    marginTop: theme.marginBase / 2,
  },
}));

export const MenuWindow = (props: MenuProps) => {
  const classes = useStyles();

  return (
    <Menu
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      {...props}
      className={classNames(props.className, classes.menu)}
      sx={{ zIndex: 1600, ...props.sx }}
    />
  );
};
